import { debug } from './debug';

/**
 * Safe wrapper for sessionStorage that handles errors gracefully
 * (e.g., Safari Private Mode, storage quota exceeded)
 */
export const safeSessionStorage = {
  getItem: (key: string): string | null => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      debug('Failed to get from sessionStorage:', error);
      return null;
    }
  },

  setItem: (key: string, value: string): void => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      debug('Failed to save to sessionStorage:', error);
      // Silent fail - storage might be full or disabled
    }
  },

  removeItem: (key: string): void => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      debug('Failed to remove from sessionStorage:', error);
      // Silent fail
    }
  },

  clear: (): void => {
    try {
      sessionStorage.clear();
    } catch (error) {
      debug('Failed to clear sessionStorage:', error);
      // Silent fail
    }
  },
};
